import { useEffect } from 'react';
import { useLayoutPrefs } from './layoutPrefs';

/**
 * Global keyboard shortcuts for ERP Shell navigation:
 * - `[`: Toggle left sidebar navigation
 * - `]`: Toggle right recent activity sidebar
 * - Ignores keydown events originating inside inputs, textareas, selects, or editable content.
 */
export function useShellShortcuts() {
  const { toggleLeft, toggleRight } = useLayoutPrefs();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      if (target) {
        const tagName = target.tagName;
        if (
          tagName === 'INPUT' ||
          tagName === 'TEXTAREA' ||
          tagName === 'SELECT' ||
          target.isContentEditable
        ) {
          return;
        }
      }

      if (e.key === '[') {
        e.preventDefault();
        toggleLeft();
      } else if (e.key === ']') {
        e.preventDefault();
        toggleRight();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggleLeft, toggleRight]);
}
